import { Reveal } from "@/components/Reveal";
import { cn } from "@/lib/utils";

// Editorial section heading: mono overline (numbered chapter) + display title + optional lead.
export function SectionHeading({ chapter, overline, title, lead, align = "left", dark = false, className = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal className={cn("flex flex-col gap-4 max-w-3xl", alignCls, className)}>
      {(overline || chapter) && (
        <div className={cn("flex items-center gap-3 overline", dark ? "text-butter-deep" : "text-forest/60")}>
          {chapter && <span className={cn("px-2 py-0.5 rounded-md border", dark ? "border-butter-deep/50" : "border-forest/30")}>{chapter}</span>}
          {overline && <span>{overline}</span>}
        </div>
      )}
      <h2 className={cn("font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-balance", dark ? "text-cream" : "text-forest")}>
        {title}
      </h2>
      {lead && (
        <p className={cn("text-base md:text-lg leading-relaxed max-w-2xl", dark ? "text-cream/70" : "text-forest/70")}>
          {lead}
        </p>
      )}
    </Reveal>
  );
}

// Page hero used across inner pages
export function PageHero({ chapter, title, lead, image, children }) {
  return (
    <section className="relative pt-[74px] overflow-hidden bg-forest text-cream">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-forest/70" />
        </div>
      )}
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <Reveal>
          <span className="overline text-butter-deep">{chapter}</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-4 max-w-4xl text-balance">
            {title}
          </h1>
          {lead && <p className="text-cream/75 text-lg mt-6 max-w-2xl leading-relaxed">{lead}</p>}
          {children && <div className="mt-8">{children}</div>}
        </Reveal>
      </div>
    </section>
  );
}
